import { Navigate, Outlet, useLocation } from 'react-router-dom'

import { Paths } from '../../lib/constants/path'
import useAuth from '../../lib/hooks/use-auth'

const GuestGuard = () => {
  const { user } = useAuth()
  const { pathname } = useLocation()

  return (
    <>
      {!user ? (
        <Outlet />
      ) : (
        <Navigate replace to={Paths.DEFAULT_PAGE} state={{ from: pathname }} />
      )}
    </>
  )
}

export default GuestGuard
